import { BgColorsOutlined, TagOutlined } from "@ant-design/icons";

import {
  Card,
  Row,
  Col,
  Typography,
  Button,
  Form,
  Input,
  InputNumber,
  Select,
  Alert,
  FormInstance,
  Spin,
  message,
} from "antd";
import { Collab } from "interfaces/collab";
import { useCallback, useEffect, useLayoutEffect, useState } from "react";
import { useSelector } from "react-redux";
import { BusinessState } from "redux-context/business";
import {
  getCreativeFreedomPromotion,
  getDeliveryPromotion,
  getDiscountedOfferPromotion,
} from "services/SauceService";
import { PromotionChannelStep, PromotionTypeStep } from "./PromotionSteps";

const { Text, Title } = Typography;
const { Option } = Select;

type PromotionsProps = {
  form: FormInstance<any>;
  collab?: Collab;
  onContinue: () => void;
  onBack: () => void;
  onPromotionTypeSelected?: (promotionType: string) => void;
  startingStepNumber?: number;
  totalSteps?: number;
  title?: string;
};

interface CardItem {
  key: string;
  icon: React.ReactNode;
  title: string;
  description: string;
  bullets: (string | { icon: React.ReactNode; text: string })[];
  tags: string[];
  requirement?: string;
}

const cardData: CardItem[] = [
  {
    key: "creative-freedom",
    icon: <BgColorsOutlined style={{ fontSize: 32 }} />,
    title: "Creative Freedom",
    description:
      "Let creators showcase your brand authentically with their unique creative style",
    bullets: [
      {
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <g clip-path="url(#clip0_99_3754)">
              <path
                d="M14 8C14 7.21207 13.8448 6.43185 13.5433 5.7039C13.2417 4.97595 12.7998 4.31451 12.2426 3.75736C11.6855 3.20021 11.0241 2.75825 10.2961 2.45672C9.56815 2.15519 8.78793 2 8 2C7.21207 2 6.43185 2.15519 5.7039 2.45672C4.97595 2.75825 4.31451 3.20021 3.75736 3.75736C3.20021 4.31451 2.75825 4.97595 2.45672 5.7039C2.15519 6.43185 2 7.21207 2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8ZM0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8ZM8 10.5C8.66304 10.5 9.29893 10.2366 9.76777 9.76777C10.2366 9.29893 10.5 8.66304 10.5 8C10.5 7.33696 10.2366 6.70107 9.76777 6.23223C9.29893 5.76339 8.66304 5.5 8 5.5C7.33696 5.5 6.70107 5.76339 6.23223 6.23223C5.76339 6.70107 5.5 7.33696 5.5 8C5.5 8.66304 5.76339 9.29893 6.23223 9.76777C6.70107 10.2366 7.33696 10.5 8 10.5ZM8 3.5C9.19347 3.5 10.3381 3.97411 11.182 4.81802C12.0259 5.66193 12.5 6.80653 12.5 8C12.5 9.19347 12.0259 10.3381 11.182 11.182C10.3381 12.0259 9.19347 12.5 8 12.5C6.80653 12.5 5.66193 12.0259 4.81802 11.182C3.97411 10.3381 3.5 9.19347 3.5 8C3.5 6.80653 3.97411 5.66193 4.81802 4.81802C5.66193 3.97411 6.80653 3.5 8 3.5ZM7 8C7 7.73478 7.10536 7.48043 7.29289 7.29289C7.48043 7.10536 7.73478 7 8 7C8.26522 7 8.51957 7.10536 8.70711 7.29289C8.89464 7.48043 9 7.73478 9 8C9 8.26522 8.89464 8.51957 8.70711 8.70711C8.51957 8.89464 8.26522 9 8 9C7.73478 9 7.48043 8.89464 7.29289 8.70711C7.10536 8.51957 7 8.26522 7 8Z"
                fill="#1D2023"
              />
            </g>
            <defs>
              <clipPath id="clip0_99_3754">
                <path d="M0 0H16V16H0V0Z" fill="white" />
              </clipPath>
            </defs>
          </svg>
        ),
        text: "High authenticity",
      },
      {
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M2 2C2 1.44687 1.55313 1 1 1C0.446875 1 0 1.44687 0 2V12.5C0 13.8813 1.11875 15 2.5 15H15C15.5531 15 16 14.5531 16 14C16 13.4469 15.5531 13 15 13H2.5C2.225 13 2 12.775 2 12.5V2ZM14.7063 4.70625C15.0969 4.31563 15.0969 3.68125 14.7063 3.29063C14.3156 2.9 13.6812 2.9 13.2906 3.29063L10 6.58437L8.20625 4.79063C7.81563 4.4 7.18125 4.4 6.79063 4.79063L3.29063 8.29062C2.9 8.68125 2.9 9.31563 3.29063 9.70625C3.68125 10.0969 4.31563 10.0969 4.70625 9.70625L7.5 6.91563L9.29375 8.70938C9.68437 9.1 10.3188 9.1 10.7094 8.70938L14.7094 4.70937L14.7063 4.70625Z"
              fill="#1D2023"
            />
          </svg>
        ),
        text: "Natural engagement",
      },
    ],
    tags: ["UGC", "Awareness"],
  },
  // {
  //   key: "delivery-promotion",
  //   icon: <CarOutlined style={{ fontSize: 24 }} />,
  //   title: "Delivery Promotion",
  //   description: "Increase delivery orders through influencer partnerships",
  //   bullets: ["Drive delivery sales", "Reach new customers"],
  //   tags: ["Sales", "Awareness"],
  // },
  // {
  //   key: "reservation-promotion",
  //   icon: <CalendarOutlined style={{ fontSize: 24 }} />,
  //   title: "Reservation",
  //   description: "Drive in-house dining through targeted promotions",
  //   bullets: ["Increase bookings", "Premium experience"],
  //   tags: ["Sales", "Engagement"],
  // },
  {
    key: "discounted-offers",
    icon: <TagOutlined style={{ fontSize: 32 }} />,
    title: "Promo Offers",
    description: "Drive immediate sales with special promotional offers",
    bullets: [
      {
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="16"
            viewBox="0 0 18 16"
            fill="none"
          >
            <path
              d="M0 3.51566V13.1969C0 13.7594 0.315625 14.2907 0.84375 14.4875C3.5625 15.5032 6.28125 14.8094 9 14.1157C11.4937 13.4813 13.9875 12.8438 16.4781 13.525C17.1969 13.7219 18 13.2282 18 12.4813V2.80316C18 2.24066 17.6844 1.70941 17.1562 1.51254C14.4375 0.496914 11.7188 1.19066 9 1.88441C6.50625 2.51879 4.0125 3.15316 1.52188 2.47191C0.8 2.27504 0 2.76879 0 3.51566ZM9 11C7.61875 11 6.5 9.65629 6.5 8.00004C6.5 6.34379 7.61875 5.00004 9 5.00004C10.3813 5.00004 11.5 6.34379 11.5 8.00004C11.5 9.65629 10.3813 11 9 11ZM2 11C3.10313 11 4 11.8969 4 13H2V11ZM4 4.50004C4 5.60316 3.10313 6.50004 2 6.50004V4.50004H4ZM16 9.50004V11.5H14C14 10.3969 14.8969 9.50004 16 9.50004ZM14 3.00004H16V5.00004C14.8969 5.00004 14 4.10316 14 3.00004Z"
              fill="#1D2023"
            />
          </svg>
        ),
        text: "Quick conversion",
      },
      {
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="16"
            viewBox="0 0 20 16"
            fill="none"
          >
            <g clip-path="url(#clip0_99_3846)">
              <path
                d="M3 4C3 2.93913 3.42143 1.92172 4.17157 1.17157C4.92172 0.421427 5.93913 0 7 0C8.06087 0 9.07828 0.421427 9.82843 1.17157C10.5786 1.92172 11 2.93913 11 4C11 5.06087 10.5786 6.07828 9.82843 6.82843C9.07828 7.57857 8.06087 8 7 8C5.93913 8 4.92172 7.57857 4.17157 6.82843C3.42143 6.07828 3 5.06087 3 4ZM0 15.0719C0 11.9937 2.49375 9.5 5.57188 9.5H8.42813C11.5063 9.5 14 11.9937 14 15.0719C14 15.5844 13.5844 16 13.0719 16H0.928125C0.415625 16 0 15.5844 0 15.0719ZM15.75 9.75V7.75H13.75C13.3344 7.75 13 7.41563 13 7C13 6.58437 13.3344 6.25 13.75 6.25H15.75V4.25C15.75 3.83437 16.0844 3.5 16.5 3.5C16.9156 3.5 17.25 3.83437 17.25 4.25V6.25H19.25C19.6656 6.25 20 6.58437 20 7C20 7.41563 19.6656 7.75 19.25 7.75H17.25V9.75C17.25 10.1656 16.9156 10.5 16.5 10.5C16.0844 10.5 15.75 10.1656 15.75 9.75Z"
                fill="#1D2023"
              />
            </g>
            <defs>
              <clipPath id="clip0_99_3846">
                <path d="M0 0H20V16H0V0Z" fill="white" />
              </clipPath>
            </defs>
          </svg>
        ),
        text: "New customer acquisition",
      },
    ],
    tags: ["Sales", "Conversion"],
  },
];

type FormProps = {
  onBack: () => void;
  handleContinue: (formFields: any) => void;
  values?: any;
  selectedChannel?: string;
  startingStepNumber?: number;
  totalSteps?: number;
};

const DeliveryPromotionForm: React.FC<FormProps> = ({
  onBack,
  handleContinue,
  values,
  selectedChannel,
}) => {
  const [form] = Form.useForm();

  const { business } = useSelector((state: BusinessState) => state.business);
  const handleSubmit = async () => {
    try {
      const fields = await form.validateFields();
      const venue = values?.venue || {};
      const response = await getDeliveryPromotion({
        businessId: business._id,
        venueId: venue.uuid,
        channel: selectedChannel,
        ...fields,
      });
      handleContinue(response);
    } catch (error) {
      // Validation error
    }
  };

  return (
    <Form layout="vertical" form={form}>
      <Title level={4}>Delivery Promotion Setup</Title>
      <Form.Item label="Your first-party delivery provider" name="provider">
        <Select placeholder="Select provider">
          <Option value="provider1">Provider 1</Option>
          <Option value="provider2">Provider 2</Option>
          <Option value="provider3">Provider 3</Option>
        </Select>
      </Form.Item>
      <Alert
        message="We recommend matching third-party commission rates with first-party discounts. If you pay 15% commission to third parties, offering the same discount on direct orders will drive traffic while maintaining customer data ownership."
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
      />
      <Form.Item label="Discount for Order Food button (%)" name="discount">
        <InputNumber
          style={{ width: "100%" }}
          min={0}
          max={100}
          formatter={(v) => `${v}%`}
          parser={(v) => v?.replace("%", "") as any}
        />
      </Form.Item>
      <Form.Item label="Direct ordering link" name="link">
        <Input placeholder="https://your-ordering-website.com" />
      </Form.Item>
      <Form.Item label="Optional promo code" name="promoCode">
        <Input placeholder="INSTA2025" />
        <Text type="secondary">Leave empty if no code is needed</Text>
      </Form.Item>

      <Row style={{ gap: 32, marginTop: 32 }}>
        <Button
          type="primary"
          className="label-strong"
          htmlType="button"
          onClick={handleSubmit}
        >
          Continue
        </Button>
        <Button
          onClick={onBack}
          className="text-strong-large"
          htmlType="button"
        >
          Back
        </Button>
      </Row>
    </Form>
  );
};

const ReservationPromotionForm: React.FC<FormProps> = ({
  onBack,
  handleContinue,
}) => {
  const [form] = Form.useForm();
  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      handleContinue(values);
    } catch (error) {
      console.error("Validation failed:", error);
    }
  };
  return (
    <Form layout="vertical" form={form}>
      <Title level={4}>Reservation Promotion Setup</Title>
      {/* Add form fields here */}
      <Row style={{ gap: 32, marginTop: 32 }}>
        <Button
          type="primary"
          className="label-strong"
          htmlType="button"
          onClick={handleSubmit}
        >
          Continue
        </Button>
        <Button
          onClick={onBack}
          className="text-strong-large"
          htmlType="button"
        >
          Back
        </Button>
      </Row>
    </Form>
  );
};

const DiscountedOffersForm: React.FC<FormProps> = ({
  onBack,
  handleContinue,
  selectedChannel,
  values,
  startingStepNumber,
  totalSteps,
}) => {
  const [form] = Form.useForm();
  const { business } = useSelector((state: BusinessState) => state.business);
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingMessage, setLoadingMessage] = useState<string>(
    "Retrieving best practices...",
  );
  const handleSubmit = async () => {
    setLoading(true);
    setTimeout(() => {
      setLoadingMessage("Completing missing details...");
      setTimeout(() => {
        setLoadingMessage("Crafting the message...");
      }, 2000);
    }, 2000);
    try {
      const fields = await form.validateFields();
      const venue = values?.venue || {};
      const response = await getDiscountedOfferPromotion({
        businessId: business._id,
        venueId: venue.uuid,
        channel: selectedChannel,
        ...fields,
      });
      setTimeout(() => handleContinue(response), 5000);
    } catch (error) {
      message.error(
        "An error occurred while submitting the form. Please try again.",
      );
    }
    setTimeout(() => setLoading(false), 5000);
  };

  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={handleSubmit}
      style={{ margin: "0 auto" }}
    >
      <Spin
        spinning={loading}
        tip={
          <span style={{ fontSize: 20, display: "block", marginTop: 20 }}>
            {loadingMessage}
          </span>
        }
        size="large"
      >
        <Row>
          <Col xs={16}>
            <Title level={3} style={{ marginBottom: 24 }}>
              Promo Offer Details
            </Title>
          </Col>
          {startingStepNumber && (
            <Col
              xs={8}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                color: "#666666",
              }}
            >
              Step {startingStepNumber + 1} / {totalSteps}
            </Col>
          )}
        </Row>
        <Form.Item
          label="Offer short description"
          name="description"
          rules={[
            { required: true, message: "Please enter a short description" },
          ]}
        >
          <Input.TextArea
            placeholder="Short description of what's being offered"
            autoSize={{ minRows: 3, maxRows: 4 }}
          />
        </Form.Item>
        <Form.Item
          label="Value"
          name="value"
          rules={[{ required: true, message: "Please enter a value" }]}
        >
          <InputNumber
            style={{ width: "100%" }}
            min={0}
            formatter={(v) => `$ ${v}`}
            parser={(v) => v?.replace(/\$\s?|(,*)/g, "") as any}
            placeholder="$ 0.00"
          />
        </Form.Item>
        <Form.Item label="Availability" name="availability">
          <Input placeholder="e.g. Valid until June 30, 2025" />
        </Form.Item>
        <Form.Item label="Discount" name="discount">
          <Input placeholder="e.g. 20% off entire check or $10 off the meal" />
        </Form.Item>
        <Form.Item
          label={
            <span>
              Code to redeem{" "}
              <span style={{ color: "#b0b0b0", fontWeight: 400 }}>
                (optional)
              </span>
            </span>
          }
          name="code"
        >
          <Input placeholder="e.g. SUMMER2025" />
        </Form.Item>
        <Form.Item
          label={
            <span>
              Link to redeem{" "}
              <span style={{ color: "#b0b0b0", fontWeight: 400 }}>
                (optional)
              </span>
            </span>
          }
          name="link"
        >
          <Input
            prefix={
              <span role="img" aria-label="link" style={{ color: "#b0b0b0" }}>
                🔗
              </span>
            }
            placeholder="https://your-brand.com/redeem"
          />
        </Form.Item>
        <Form.Item
          label={
            <span>
              Redemption DM Keyword{" "}
              <span style={{ color: "#b0b0b0", fontWeight: 400 }}>
                (optional)
              </span>
            </span>
          }
          name="dmKeyword"
        >
          <Input
            prefix={
              <span
                role="img"
                aria-label="hashtag"
                style={{ color: "#b0b0b0" }}
              >
                #
              </span>
            }
            placeholder="e.g. DISCOUNT25"
          />
        </Form.Item>
        <Form.Item
          label={
            <span>
              DM Response{" "}
              <span style={{ color: "#b0b0b0", fontWeight: 400 }}>
                (optional)
              </span>
            </span>
          }
          name="dmResponse"
        >
          <Input.TextArea
            placeholder="Auto-response when someone DMs the keyword..."
            autoSize={{ minRows: 2, maxRows: 4 }}
          />
        </Form.Item>
        <Row
          style={{ gap: 32, marginTop: 32, justifyContent: "space-between" }}
        >
          <Button
            onClick={onBack}
            className="text-strong-large"
            htmlType="button"
            style={{ minWidth: 100 }}
          >
            Back
          </Button>
          <Button
            type="primary"
            className="label-strong"
            htmlType="submit"
            style={{
              minWidth: 120,
              background: "#ffac39",
              borderColor: "#ffac39",
            }}
            loading={loading}
          >
            Continue
          </Button>
        </Row>
      </Spin>
    </Form>
  );
};

const CreativeFreedomForm: React.FC<FormProps> = ({
  onBack,
  handleContinue,
  values,
  selectedChannel,
  startingStepNumber,
  totalSteps,
}) => {
  const { business } = useSelector((state: BusinessState) => state.business);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [loadingMessage, setLoadingMessage] = useState<string>(
    "Retrieving best practices...",
  );

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    setTimeout(() => {
      setLoadingMessage("Completing missing details...");
      setTimeout(() => {
        setLoadingMessage("Crafting the message...");
      }, 2000);
    }, 2000);
    try {
      const venue = values?.venue || {};
      const response = await getCreativeFreedomPromotion({
        businessId: business._id,
        venueId: venue.uuid,
        channel: selectedChannel,
      });

      if (response) {
        setTimeout(() => handleContinue(response), 5000);
      }
    } catch (error) {
      console.error("Failed to fetch promotion data:", error);
      setError("An error occurred while fetching the promotion data.");
    }
    setTimeout(() => setLoading(false), 5000);
  }, [business._id, handleContinue, values?.venue, selectedChannel]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div>
      <Row>
        <Col xs={16}>
          <Typography.Title level={3} style={{ fontSize: 32 }}>
            Generating Instructions
          </Typography.Title>
        </Col>
        {startingStepNumber && (
          <Col
            xs={8}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              color: "#666666",
            }}
          >
            Step {startingStepNumber + 1} / {totalSteps}
          </Col>
        )}
      </Row>

      <Row style={{ gap: 32, marginTop: 32 }}>
        <Spin
          spinning={loading}
          tip={
            <span style={{ fontSize: 20, display: "block", marginTop: 20 }}>
              {loadingMessage}
            </span>
          }
          size="large"
        >
          <Row>
            <Typography.Text style={{ width: 500 }}>
              {error
                ? "  An error occurred while fetching the creative freedom setup."
                : " "}
            </Typography.Text>
          </Row>
          <Row
            style={{
              gap: 32,
              marginTop: 32,
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Button
              onClick={onBack}
              className="text-strong-large"
              htmlType="button"
            >
              Back
            </Button>

            {!loading && (
              <Button
                type="primary"
                className="label-strong"
                htmlType="button"
                onClick={fetchData}
                style={{
                  minWidth: 120,
                  background: "#ffac39",
                  borderColor: "#ffac39",
                }}
              >
                Try again
              </Button>
            )}
          </Row>
        </Spin>
      </Row>
    </div>
  );
};

// const BehindTheScenesForm: React.FC<FormProps> = ({
//   onBack,
//   handleContinue,
// }) => {
//   const [form] = Form.useForm();

//   const handleSubmit = async () => {
//     const values = await form.validateFields();
//     handleContinue(values);
//   };

//   return (
//     <Form layout="vertical" form={form}>
//       <Title level={4}>Behind the Scenes Setup</Title>
//       {/* Add form fields here */}
//       <Row style={{ gap: 32, marginTop: 32 }}>
//         <Button
//           type="primary"
//           className="label-strong"
//           htmlType="button"
//           onClick={handleSubmit}
//         >
//           Continue
//         </Button>
//         <Button
//           onClick={onBack}
//           className="text-strong-large"
//           htmlType="button"
//         >
//           Back
//         </Button>
//       </Row>
//     </Form>
//   );
// };

enum Step {
  SELECT_PROMO = 1,
  SELECT_CHANNEL = 2,
  FORM = 3,
}

const Promotions: React.FC<PromotionsProps> = (props) => {
  const {
    form,
    collab,
    onContinue,
    onBack,
    onPromotionTypeSelected,
    startingStepNumber,
    totalSteps,
    title,
  } = props;
  const socialMediaName = form.getFieldValue("socialMediaName");
  const [selectedKey, setSelectedKey] = useState<string | undefined>(
    "creative-freedom",
  );
  const [step, setStep] = useState<Step>(Step.SELECT_PROMO);
  const [selectedChannel, setSelectedChannel] = useState<string>(
    socialMediaName ?? "instagram",
  );

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [step]);

  const handleSelect = (key: string) => {
    setSelectedKey(key);
    onPromotionTypeSelected?.(key);
  };

  const parseNewDeliverablesToOldFormat = (newDeliverables: any) => {
    return {
      tiktokVideo: newDeliverables.tiktokVideo?.length > 0,
      instagramReel: newDeliverables.instagramReel?.length > 0,
      instagramStory: newDeliverables.instagramStory?.length > 0,
      googleReview: false,
      yelpReview: false,
    };
  };

  const handleContinue = (fieldsValue: any) => {
    setStep(Step.FORM);
    const collabInstructions = form.getFieldValue("collabInstructions") || {};
    form.setFieldValue("focusPoints", fieldsValue.instructions);
    form.setFieldValue("collabInstructions", {
      ...collabInstructions,
      promotionName: fieldsValue.promotionName,
      tiktokVideo: fieldsValue.tiktokVideo,
      instagramReel: fieldsValue.instagramReel,
      instagramStory: fieldsValue.instagramStory,
    });
    form.setFieldValue(
      "deliverables",
      parseNewDeliverablesToOldFormat(fieldsValue),
    );
    onContinue();
  };

  const formComponents: Record<string, React.FC<FormProps>> = {
    "delivery-promotion": DeliveryPromotionForm,
    "reservation-promotion": ReservationPromotionForm,
    "creative-freedom": CreativeFreedomForm,
    "discounted-offers": DiscountedOffersForm,
  };

  return (
    <Row className="collab">
      {title && (
        <Col xs={24}>
          <Typography.Title>{title}</Typography.Title>
        </Col>
      )}

      <Col xs={24}>
        <Card
          style={{
            // padding: isMobile ? 0 : "48px 120px",
            padding: 24,
            borderRadius: collab ? "0 0 8px 8px" : 8,
            minHeight: 400,
          }}
          bordered={false}
          className="collab-promotion-card"
        >
          {step === Step.FORM ? (
            (() => {
              const FormComponent = selectedKey
                ? formComponents[selectedKey]
                : null;
              if (!FormComponent) return null;
              return (
                <FormComponent
                  onBack={() => setStep(Step.SELECT_PROMO)}
                  handleContinue={handleContinue}
                  values={form.getFieldsValue(true)}
                  selectedChannel={selectedChannel}
                  startingStepNumber={startingStepNumber}
                  totalSteps={totalSteps}
                />
              );
            })()
          ) : step === Step.SELECT_CHANNEL ? (
            <PromotionChannelStep
              selectedChannel={selectedChannel}
              setSelectedChannel={setSelectedChannel}
              onContinue={() => setStep(Step.FORM)}
              onBack={() => setStep(Step.SELECT_PROMO)}
              startingStepNumber={startingStepNumber}
              totalSteps={totalSteps}
            />
          ) : (
            <>
              <PromotionTypeStep
                cardData={cardData}
                selectedKey={selectedKey}
                onSelect={handleSelect}
                onContinue={() =>
                  socialMediaName
                    ? setStep(Step.FORM)
                    : setStep(Step.SELECT_CHANNEL)
                }
                onBack={onBack}
                startingStepNumber={startingStepNumber}
                totalSteps={totalSteps}
              />
            </>
          )}
        </Card>
      </Col>
    </Row>
  );
};

export default Promotions;
